module.exports = __webpack_public_path__ + "img/logo.bacc4b39.png";